import type { ReactNode } from "react";
import { LoadingSpinner } from "@/components/LoadingSpinner";
import { SECONDARY_BUTTON } from "./buttons";

export interface QuerySlice {
  isPending: boolean;
  isError: boolean;
  refetch: () => unknown;
}

/** Loading and failure for one or more queries; children render once all
 *  have data. */
export function Loaded({ queries, children }: { queries: QuerySlice[]; children: () => ReactNode }): React.ReactElement {
  if (queries.some((q) => q.isError)) {
    return (
      <div
        role="alert"
        className="flex flex-wrap items-center gap-3 rounded-md border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-800"
      >
        <span>This list could not be loaded.</span>
        <button type="button" onClick={() => queries.forEach((q) => void q.refetch())} className={SECONDARY_BUTTON}>
          Try again
        </button>
      </div>
    );
  }
  if (queries.some((q) => q.isPending)) return <LoadingSpinner />;
  return <>{children()}</>;
}
